import React, {useRef, useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Button} from '@components';
import {Form, Row, ProgressBar, Col} from 'react-bootstrap';
import axios from 'axios';
import {getToken} from '@app/utils/helper';
import {toast} from 'react-toastify';
import {FILE_MANAGER_API, BaseGatewayImage} from '@app/utils/apiUrl.js';

// validate/build your iframe URL
function validURL(str) {
    const pattern = new RegExp(
        '^(https?:\\/\\/)?' +
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
            '((\\d{1,3}\\.){3}\\d{1,3}))' +
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
            '(\\?[;&a-z\\d%_.~+=-]*)?' +
            '(\\#[-a-z\\d_]*)?$',
        'i'
    );
    return !!pattern.test(str);
}
const renderUrlVideo = (url) => {
    if (!validURL(url)) return BaseGatewayImage + url;
    const u = new URL(url);
    if (u.hostname === 'www.youtube.com' && url.includes('watch?v='))
        return url.replace('watch?v=', 'embed/');
    return url;
};

const MultiVideoInput = ({
    value,
    enableReinitialize,
    isInvalid,
    errorsValue,
    onChangeProp
}) => {
    const inputRef = useRef();
    // local state of video URLs
    const [videoUrls, setVideoUrls] = useState(
        Array.isArray(value) ? value : []
    );
    // one shared progress % (0–100)
    const [completed, setCompleted] = useState(0);

    // sync if parent reinitializes
    useEffect(() => {
        setVideoUrls(Array.isArray(value) ? value : []);
        // keep completed at 0 until next upload
        setCompleted(0);
    }, [value, enableReinitialize]);

    const handleUpload = async (e) => {
        const files = Array.from(e.target.files);
        if (!files.length) return;

        // optional size guard
        if (files.some((f) => f.size / 1024 / 1024 > 200)) {
            toast.error(
                'Một trong các video vượt quá 200MB, vui lòng chọn lại.'
            );
            return;
        }

        // build FormData with all files
        const form = new FormData();
        files.forEach((f) => form.append('file', f));

        try {
            setCompleted(0);
            const token = getToken();
            const res = await axios.post(FILE_MANAGER_API.UPLOAD, form, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`
                },
                onUploadProgress: (ev) => {
                    const pct = Math.round((ev.loaded * 100) / ev.total);
                    console.log(pct);
                    setCompleted(pct);
                }
            });

            // extract returned paths
            const paths = res.data.map((fm) => fm.filePath);
            setVideoUrls(paths);
            onChangeProp(paths);
            toast.success('Tải video thành công!');
            // keep completed at 100%
        } catch (err) {
            console.error(err);
            toast.error('Upload thất bại. Vui lòng thử lại.');
            setCompleted(0);
            // you could setCompleted(0) here if you want to reset on failure
        } finally {
            // allow re-selecting same files
            e.target.value = '';
        }
    };

    const isUploaded = videoUrls && videoUrls.length > 0 && completed === 0;

    return (
        <>
            {/* always-visible single bar */}
            <ProgressBar
                now={completed}
                label={`${completed}%`}
                animated
                style={{
                    display: isUploaded ? 'none' : 'flex'
                }}
                striped
                variant="success"
                className="progress-striped active w-100"
            />

            {/* previews */}
            <Row className="mb-3">
                {videoUrls.map((url, idx) => (
                    <Col key={idx} xs={12} md={6} className="mb-3">
                        <iframe
                            className="w-100"
                            style={{height: 200}}
                            src={renderUrlVideo(url)}
                            title={`video-${idx}`}
                        />
                    </Col>
                ))}
            </Row>

            {/* hidden file input + trigger */}
            <Form.Control
                type="file"
                accept="video/*"
                multiple
                hidden
                ref={inputRef}
                onChange={handleUpload}
                isInvalid={isInvalid}
            />
            <Button onClick={() => inputRef.current.click()}>Chọn video</Button>
            {errorsValue && (
                <div className="invalid-feedback d-block">{errorsValue}</div>
            )}
        </>
    );
};

MultiVideoInput.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ]),
    enableReinitialize: PropTypes.bool,
    isInvalid: PropTypes.bool,
    errorsValue: PropTypes.string,
    onChangeProp: PropTypes.func
};

MultiVideoInput.defaultProps = {
    value: [],
    enableReinitialize: false,
    isInvalid: false,
    errorsValue: '',
    onChangeProp: () => {}
};

export default MultiVideoInput;
